import {
    ADD_SHIPPING_FAIL,
    ADD_SHIPPING_SUCCESS,
    DELETE_SHIPPING_FAIL,
    DELETE_SHIPPING_SUCCESS,
    EXPORT_SHIPPING_FAIL,
    EXPORT_SHIPPING_SUCCESS,
    GET_SHIPPING_DETAILS_FAIL,
    GET_SHIPPING_DETAILS_SUCCESS,
    GET_SHIPPING_LISTING_FAIL,
    GET_SHIPPING_LISTING_SUCCESS,
    RESET_SHIPPING_ATTACHMENT_STATE,
    RESET_SHIPPING_STATE,
    UPDATE_SHIPPING_FAIL,
    UPDATE_SHIPPING_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    shippingListing: [],
    shippingDetails: [],
    addShipping: [],
    updateShipping: [],
    deleteShipping: [],
    exportShipping: [],
    error: [],
}

const Shipping = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SHIPPING_LISTING_SUCCESS:
            return {
                ...state,
                shippingListing: action.payload
            }
        case GET_SHIPPING_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_SHIPPING_DETAILS_SUCCESS:
            return {
                ...state,
                shippingDetails: action.payload
            }
        case GET_SHIPPING_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_SHIPPING_SUCCESS:
            return {
                ...state,
                addShipping: action.payload
            }
        case ADD_SHIPPING_FAIL:
            return {
                ...state,
                error: action.payload,
                addShipping: action.payload,
            }

        case UPDATE_SHIPPING_SUCCESS:
            return {
                ...state,
                updateShipping: action.payload
            }
        case UPDATE_SHIPPING_FAIL:
            return {
                ...state,
                error: action.payload,
                updateShipping: action.payload,
            }

        case DELETE_SHIPPING_SUCCESS:
            return {
                ...state,
                deleteShipping: action.payload
            }
        case DELETE_SHIPPING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_SHIPPING_SUCCESS:
            return {
                ...state,
                exportShipping: action.payload
            }
        case EXPORT_SHIPPING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_SHIPPING_STATE:
            return {
                ...state,
                shippingListing: [],
                shippingDetails: [],
                addShipping: [],
                updateShipping: [],
                deleteShipping: [],
                exportShipping: [],
                error: [],
            }
        case RESET_SHIPPING_ATTACHMENT_STATE:
            return {
                ...state,
                exportShipping: [],
                error: [],
            }
        default:
            return state
    }
}

export default Shipping
